// extracted by extract-css-chunks-webpack-plugin
module.exports = {"voucher":"css-3P-42lRZBm","voucher_added":"css-nDFTJLREPo","voucher_added_row":"css-1wsAvTgD_n","voucher_error":"css-kbEysU0uft","voucher_toggle":"css-3dM2h8FCYt"};